import moment from "moment"

export const formatAPIData = (data) => {
    const formattedData = data.reduce((r,i) => {
        r.push({
            id:i.id,
            orderIds:i.order_ids,
            title:i.title,
            description:i.description,
            referenceId:i.reference_id,
            reporterContactName:i.reporter_contact_name,
            reporterContactPhone:i.reporter_contact_phone,
            type:i.type,
            status:i.status,
            comments:i.comments,
            createdBy:i.created_by,
            createdAt:moment(i.created_at).format("DD MMM"),
            processedAt:moment(i.processed_at).format("DD MMM YYYY"),
            solvedAt:moment(i.solved_at).format("DD MMM YYYY")
        })
        return r;
    },[])

    return formattedData
}